import {BlockMath, InlineMath} from "react-katex";

const VectorIntro = () => {
  return (
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="tw-header font-bold text-gray-900 mb-4">Vectors</h1>
        <p className="text-gray-600 tw-subtitle text-justify">
          Vectors are fundamental mathematical objects that represent both
          <strong> magnitude</strong> and <strong>direction</strong> in space.
          They form the backbone of linear algebra and are essential in fields
          ranging from physics and engineering to computer graphics and machine learning.
          A vector can be represented as <InlineMath math="\vec{v} = \begin{pmatrix} x \\ y \\ z \end{pmatrix}"/>
          in 3D space, where each component represents the vector's projection along each axis.
        </p>
        <hr className="mt-2 mb-2"/>
        <p className="tw-subtitle text-gray-600">
          The magnitude (or length) of a vector is calculated using the Euclidean norm:
        </p>
        <BlockMath math="|\vec{v}| = \sqrt{x^2 + y^2 + z^2}"/>
        <p className="tw-subtitle text-gray-600">
          Two of the most important vector operations are the <strong>dot product</strong> and
          <strong> cross product</strong>. The dot product measures how much two vectors point
          in the same direction:
        </p>
        <BlockMath math="\vec{a} \cdot \vec{b} = |\vec{a}||\vec{b}|\cos\theta = a_x b_x + a_y b_y + a_z b_z"/>
        <p className="tw-subtitle text-gray-600">
          Where <InlineMath math="\theta"/> is the angle between the vectors. When the dot product
          equals zero, the vectors are <strong>orthogonal</strong> (perpendicular). These operations
          are crucial for understanding geometric relationships, solving systems of equations, and
          working with high-dimensional data in machine learning applications.
        </p>
      </div>
  );
};

export default VectorIntro;